<script setup lang="ts">
import type { StepperItem } from '#ui/types';

// PROPS
interface Props {
    items: StepperItem[];
}

defineProps<Props>();

// MODEL
const model = defineModel<string>({ required: true });

// DATA
const ui = {
    trigger:
        'bg-white group-data-[state=active]:bg-primary-50 group-data-[state=completed]:bg-success-50 border-2 border-neutral-300 shadow-neutral-300 shadow-sm group-data-[state=completed]:border-success-700 group-data-[state=completed]:shadow-success-200 group-data-[state=active]:border-primary-200 group-data-[state=active]:shadow-primary-200 focus-visible:outline-primary',
    title: 'group-data-[state=completed]:text-success-700 group-data-[state=active]:text-primary-500 group-data-[state=active]:font-bold',
    icon: 'group-data-[state=completed]:text-success-700 group-data-[state=active]:text-primary-500',
};
</script>

<template>
    <UStepper v-model="model" :items="items" size="lg" disabled :ui="ui" />
</template>
